import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const RegistrationChart = ({ data }) => {
  return (
    <div className="card">
      <h3 className="text-lg font-semibold text-foreground mb-4">Registration Trends</h3>
      <div className="w-full h-80" aria-label="Registration trends bar chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="city" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '6px'
              }}
            />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
            />
            <Bar dataKey="boysU14" fill="var(--color-primary)" name="Boys U14" />
            <Bar dataKey="girlsU15" fill="var(--color-accent)" name="Girls U15" />
            <Bar dataKey="boysU16" fill="var(--color-secondary)" name="Boys U16" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RegistrationChart;